import React from "react";

export default function StudentStatsSection({
  GlassCard,
  icons,
  sortedStudentsLength,
  newStudentsCount,
  avgAttendance
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <GlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-blue-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={icons.student} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">총 재적</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{sortedStudentsLength}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">명</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">학생</span>
        </div>
      </GlassCard>

      <GlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-yellow-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={icons.sparkles} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">새가족</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{newStudentsCount}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">명</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">이번달 등록</span>
        </div>
      </GlassCard>

      <GlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-green-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-2">
            <img src={icons.attendance} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">평균 출석</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">{isNaN(avgAttendance) ? 0 : avgAttendance}</span>
            <span className="text-sm font-bold text-gray-400 mb-1">명</span>
          </div>
          <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">최근 4주</span>
        </div>
      </GlassCard>

      <GlassCard className="p-5 flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-2 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all" noHover>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-red-400"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="p-3 rounded-2xl bg-white/60 shadow-sm border border-white/50 backdrop-blur-md mb-2">
            <img src={icons.warning} width={36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className="text-gray-500 text-sm font-bold tracking-wide mb-0.5">심방 필요</h3>
          <div className="flex items-end gap-1.5 mb-1">
            <span className="text-4xl font-black text-[#2C3E30] font-do-hyeon leading-none">0</span>
            <span className="text-sm font-bold text-gray-400 mb-1">명</span>
          </div>
          <span className="text-xs text-gray-400 bg-white/50 px-2.5 py-0.5 rounded-full border border-white/60">장기결석</span>
        </div>
      </GlassCard>
    </div>
  );
}
